import React, { useState, useEffect, useCallback } from "react";
import moment from "moment";
import { orderBy } from "natural-orderby";
import classNames from "classnames";
import ItemCard from "../ItemCard";
import AddItemDrawer from "../Cart/AddItemDrawer";

const RewardsTab = ({ rewards, cart, setCart }) => {
  const sortOptions = [
    "Item Name",
    "Points Required",
    "Items Redeemed",
    "Item Left",
    "Release Date",
  ];
  const [activeSort, setActiveSort] = useState("Release Date");
  const [sortedRewards, setSortedRewards] = useState([]);
  const [activeItem, setActiveItem] = useState(null);
  const [hasNoMail, setHasNoMail] = useState(false);

  const CheckWidth = () => {
    if (window.innerWidth > 1000) {
      return ["d-flex", "parentFlex"];
    } else {
      return ["d-flex flex-column ", ""];
    }
  };

  const ReturnChildFlex = () => {
    if (window.innerWidth > 1000) {
      return ["mb-3", "childFlex"];
    } else {
      return ["mb-3 ", ""];
    }
  };

  const [flexName, setFlexName] = useState(CheckWidth);

  const [flexChild, setFlexChild] = useState(ReturnChildFlex);
  let mobileSize = window.innerWidth;
  const setClassName = () => {
    if (mobileSize < 1000) {
      setFlexName(["d-flex flex-column ", ""]);
      setFlexChild(["mb-3 ", ""]);
    } else {
      setFlexName(["d-flex", "parentFlex"]);
      setFlexChild(["mb-3 ", "childFlex"]);
    }
  };

  const handleWindowResize = useCallback((event) => {
    const width = window.innerWidth;

    mobileSize = width;
    setClassName();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);

  useEffect(() => {
    if (activeSort === "Item Name") {
      let sorted = orderBy(rewards, [(item) => item.name]);
      setSortedRewards(sorted);
    }
    if (activeSort === "Points Required") {
      let sorted = orderBy(rewards, [
        (item) => item.redeem_points,
        (item) => item.name,
      ]);
      setSortedRewards(sorted);
    }
    if (activeSort === "Items Redeemed") {
      let sorted = orderBy(rewards, [
        (item) =>
          item.redeemed.reduce((total, redeem) => total + redeem.quantity, 0),
      ]);
      setSortedRewards(sorted);
    }
    if (activeSort === "Item Left") {
      let sorted = orderBy(rewards, [
        (item) => {
          let total = item.redeemed.reduce(
            (total, redeem) => total + redeem.quantity,
            0
          );

          return item.quantity - total;
        },
      ]);

      setSortedRewards(sorted);
    }
    if (activeSort === "Release Date") {
      let sorted = rewards.sort((a, b) =>
        moment(a.createdAt).isBefore(moment(b.createdAt))
      );
      setSortedRewards(sorted);
    }
  }, [rewards, activeSort]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-end mb-2">
        <label htmlFor="sortOptions">Sort:</label>
        <div className="ml-2">
          <select
            name="sortOptions"
            id="sortOptions"
            className="form-select mb-2"
            onChange={({ target: { value } }) => setActiveSort(value)}
            value={activeSort}
          >
            {sortOptions.map((sortOpt, index) => (
              <option key={index} value={sortOpt}>
                {sortOpt}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className={classNames(flexName)}>
        {sortedRewards && sortedRewards.length > 0 ? (
          sortedRewards.map((item, index) => (
            <div key={index} className={classNames(flexChild)}>
              <ItemCard item={item} setActiveItem={setActiveItem} />
            </div>
          ))
        ) : (
          <div className="col text-center py-4">
            <h4>No items found</h4>
          </div>
        )}
      </div>
      <AddItemDrawer
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        cart={cart}
        setCart={setCart}
        setHasNoMail={setHasNoMail}
      />
    </>
  );
};

export default RewardsTab;
